module.exports = __webpack_public_path__ + "media/images/lb/918-deb45b9b9337d34232238c7635e91ecd.svg";